import { Skeleton, Box } from "@mui/material";

const VerticalCardSkeleton = ({ value, gap }) => {
  return (
    <Box sx={{ display: "flex", gap: gap }}>
      {[...Array(value)].map((_, i) => (
        <Box
          sx={{
            width: "12vw",
            borderRadius: ".25vw",
            overflow: "hidden",
            backgroundColor: "#1a1a1a",
          }}
          key={i}
        >
          <Skeleton
            variant="rectangular"
            animation="wave"
            width="100%"
            height="12vw"
            sx={{ bgcolor: "grey.800" }}
          />
          <Box
            sx={{
              width: "12vw",
              height: "8vh",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: ".5vw",
              gap: ".5vw",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: ".5vw",
                width: "60%",
              }}
            >
              <Skeleton
                variant="text"
                animation="wave"
                height="1vw"
                width="80%"
                sx={{ bgcolor: "grey.800" }}
              />
              <Skeleton
                variant="text"
                animation="wave"
                height="0.8vw"
                width="100%"
                sx={{ bgcolor: "grey.800" }}
              />
              <Skeleton
                variant="text"
                animation="wave"
                height="0.8vw"
                width="100%"
                sx={{ bgcolor: "grey.800" }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: ".3vw",
                width: "40%",
              }}
            >
              <Skeleton
                variant="circular"
                animation="wave"
                width="1.5vw"
                height="1.5vw"
                sx={{ bgcolor: "grey.800" }}
              />
              <Skeleton
                variant="text"
                animation="wave"
                height="0.7vw"
                width="100%"
                sx={{ bgcolor: "grey.800" }}
              />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default VerticalCardSkeleton;
